<template>
  <div class="py-4">
    <h1 class="text-center">Qui sommes nous ?</h1>
    <section class="section">
      <Us no-redirect />
    </section>
    <section class="section section--colored"> 
      <Collab />
    </section>
  </div>
</template>

<script>
import Us from '../components/home/Us.vue'
import Collab from '../components/home/Collab.vue'
import { mapGetters } from 'vuex'

export default {
  components: { Us, Collab },
  computed: {
    ...mapGetters('strapiv2', ['founder'])
  }
}
</script>